<template>
    <large-button class="w3-theme-action" @click.stop.prevent="OpenGoogleMaps()"><slot>Open Map</slot></large-button>
</template>
<script>

export default {    
  props:["latitude","longitude"],
  methods:{
    OpenGoogleMaps(){
        window.open(`https://www.google.com/maps/?q=${this.latitude},${this.longitude}`)

    }  
  }
};
</script>
  <style>
   
  </style>


// WEBPACK FOOTER //
// src/components/shared/controls/buttons/OpenGoogleMaps.vue